/**
 *Return the correct base api url base on the context of client and server
 */
export default function useBaseApiUrl(): string {
	const config = useRuntimeConfig();
	if (import.meta.client) {
		return config.public.clientApiBaseUrl;
	}

	return config.serverApiBaseUrl;
}
